<!-- FinishAgentRenewLicense -->
<template>
    <div class="container ps-lg-5 pe-lg-5">
        <div class="row">
            <div class="col-12 col-lg-12 mt-lg-5 text-center">
                <div class="icon-thankyou">
                    <img src="@/assets/images/icon-thankyou.svg" class="w-100" />
                </div>
                <h1 class="blue-1 fw-normal">THANK YOU</h1>
                <h3 class="blue-1 fw-normal name font-family">
                    เรียนคุณ {{ this.$store.state.UserName }}
                </h3>
                <div class="content pt-lg-3 fw-normal font-family fs-4">
                    <p style="margin-bottom: 0rem">
                        ท่านได้ทำการยืนยันการส่งคำร้องขอต่ออายุใบอนุญาตเป็นตัวแทนประกันชีวิตสำเร็จเรียบร้อยแล้ว<br>
                        ข้อมูลดังกล่าวจะยังไม่ได้รับการอัปเดตจนกว่าเจ้าหน้าที่จะทำการตรวจสอบ </p>
                </div>
                <div class="col-12">
                    <div class="row">
                        <div class="col-2 col-lg-3 col-sm-4"></div>
                        <div class="col col-lg-6 font-family fs-4">
                            <p style="margin-bottom: 0rem">
                                ท่านสามารถติดตามสถานะของรายการได้จาก
                            </p>
                            <ul class="">
                                <li>ระบบ Agency E-Request เมนู ประวัติการแก้ไข</li>
                                <li>ระบบ Bangkok Life Training เมนูสถานะการสมัครของผู้ประสงค์เป็นตัวแทน</li>
                            </ul>
                        </div>
                        <div class="col-2 col-lg-2 col-sm-4"></div>
                    </div>
                </div>
                <div class="content pt-lg-2 fw-normal fs-4">
                    <p class="font-family" style="margin-bottom: 0rem">
                        หากท่านมีข้อสงสัยกรุณาติดต่อ
                    </p>
                    <p class="font-family" style="margin-bottom: 0rem">
                        ส่วนสัญญาตัวแทน บมจ.กรุงเทพประกันชีวิต
                    </p>
                    <p class="blue-1 fw-bold fs-6">โทร. 02-777-8560,8567</p>
                </div>
                <div class="mt-lg-4 mb-lg-4 d-none d-none d-lg-block">
                    <router-link to="/AgenteService" class="btn-back fw-normal font-family text-decoration-none">
                        กลับไปหน้าแรก </router-link>
                </div>
                <router-link to="/AgenteService"
                    class="btn-back mt-1 mb-2 fw-normal d-lg-none font-family text-decoration-none"> กลับไปหน้าแรก
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FinishAgentRenewLicense'
}
</script>

<style scoped>
.name {
    font-size: 30px;
    font-size: 1.875rem;
}
</style>